import { preventDefault } from "@grrr/utils";

export const contact = function (el) {
    el.querySelector(".contact").addEventListener("click", function (e) {
        preventDefault(e);
        document.querySelector(".footer__inner").style.height = window.getComputedStyle(
            document.querySelector(".footer__inner")
        ).height;

        el.querySelector(".footer__contact").style.display = "block";
        el.querySelector(".footer__menu").style.display = "none";
    });

    el.querySelector(".footer__contact-close").addEventListener(
        "click",
        function (e) {
            preventDefault(e);
            el.querySelector(".footer__contact").style.display = "none";
            el.querySelector(".footer__menu").style.display = "flex";
        }
    );
};
